"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var generateOtpToken_1 = require("./generateOtpToken");
Object.defineProperty(exports, "generateOtpToken", { enumerable: true, get: function () { return generateOtpToken_1.default; } });
var generatePrivateSeed_1 = require("./generatePrivateSeed");
Object.defineProperty(exports, "generatePrivateSeed", { enumerable: true, get: function () { return generatePrivateSeed_1.default; } });
//# sourceMappingURL=index.js.map